<template>

  <section id="contact-us-section">
    <a class="anchor" id="contact-us"></a>
    <h2 class="title">{{$t('contactUs')}}</h2>
    <form id="form" action="https://formspree.io/xzbgvzbk" method="POST">
      <b-field :label="$t('name')" label-position="on-border">
          <b-input value="" name="name"></b-input>
      </b-field>

      <b-field :label="$t('email')"
          label-position="on-border">
          <b-input type="email"
              value=""
              maxlength="30"
              name="_replyto">
          </b-input>
      </b-field>
      <b-field  :label="$t('content')" label-position="on-border" required>
          <b-input name="subject"></b-input>
      </b-field>
      <b-field :label="$t('message')"  label-position="on-border">
        <b-input type="textarea" name="message"></b-input>
      </b-field>
      <b-field><!-- Label left empty for spacing -->
          <p class="control" style="text-align: right;">
              <button class="button is-primary" type="submit">
                {{$t('sendMsg')}}
              </button>
          </p>
      </b-field>
    </form>
    <video autoplay muted loop id="myVideo">
      <source src="../assets/video/bg.webm" type="video/webm">
    </video>
    <img class="deco-up" src="../assets/SVG/drops.svg">
    <div class="overlay"></div>
  </section>
</template>

<script>

export default {
  name: 'ContactUs',
  components: {
  },
  props: {
    msg: String
  }
}
</script>

<style scoped>
#myVideo {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: fill;
  width: 100%;
  min-height: 100%;
  height: auto;
  z-index: -100;
  background: rgba(0, 0, 0, 0.5);
}
.overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -50;
  background: rgba(0, 0, 0, 0.5);
}
.deco-up {
  position: absolute;
  top: -3px;
  left: 0;
  width: 200px;
}

/* Add some content at the bottom of the video/page */
#contact-us-section {
  position: relative;
  bottom: 0;
  color: #f1f1f1;
  width: 100%;
  padding-top: 15px;
  height: 650px;
  overflow: hidden;
}
h2 {
    font-size: 48px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 20px;
    padding-top: 30px;
    color: white;
}
#form {
  background-color: white;
  padding: 40px;
  border-radius: 5px;
  max-width: 600px;
  margin: 0 auto;
}
@media only screen and (max-width: 600px){
    .deco-up {
        display: none;
    }
}
   
</style>